package app.nestbridge.domain.identity.service

import app.nestbridge.domain.identity.api.UserApiClient
import app.nestbridge.domain.identity.model.User
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class, boundType = UserService::class)
@Inject
class DefaultUserService(
    private val apiClient: UserApiClient,
) : UserService {

    override suspend fun getCurrent(): User? = apiClient.fetchCurrent()?.toDomain()

    override suspend fun save(user: User): User = apiClient.save(user.toDto()).toDomain()
}
